import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { SummaryActions } from './summary.actions';
import { SummaryService } from '../../service/summary.service';


@Injectable()
export class SummaryEffects {

  loadSummary$ = createEffect(
    (summaryService: SummaryService = inject(SummaryService)) => {
      return this.actions$.pipe(
        ofType(SummaryActions.loadSummary),
        switchMap(({ campaignId, attestationId, parameters }) =>
          summaryService.getSummary(campaignId, attestationId, parameters).pipe(
            map((summary) =>
              SummaryActions.loadSummarySuccess({
                summary
              })
            ),
            catchError((error) => {
              return of(SummaryActions.loadSummaryFailure({ error }));
            })
          )
        )
      );
    },
    { functional: true }
  );

  loadAllSummary$ = createEffect(
    (summaryService: SummaryService = inject(SummaryService)) => {
      return this.actions$.pipe(
        ofType(SummaryActions.loadAllSummary),
        switchMap(({ campaignId, attestationId, parameters }) =>
          summaryService.getSummary(campaignId, attestationId, parameters).pipe(
            map((summary) =>
              SummaryActions.loadAllSummarySuccess({
                summary
              })
            ),
            catchError((error) => {
              return of(SummaryActions.loadAllSummaryFailure({ error }));
            })
          )
        )
      );
    },
    { functional: true }
  );


  exportSummary$ = createEffect(
    (summaryService: SummaryService = inject(SummaryService)) => {
      return this.actions$.pipe(
        ofType(SummaryActions.exportSummary),
        mergeMap(({ attestationId, campaignId, parameters, timeZone }) =>
          summaryService.exportSummary(campaignId, attestationId, parameters, timeZone).pipe(
            map((file) => {
              // Download diretto del file (se presente)
              if (file?.data && file.data.length > 0) {
                const f = file.data[0];
                const byteChars = atob(f!.content);
                const byteNumbers = new Array(byteChars.length);
                for (let i = 0; i < byteChars.length; i++) {
                  byteNumbers[i] = byteChars.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const link = window.document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = f!.filename ?? "summary.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
              }
              return SummaryActions.exportSummarySuccess({
                export: file
              });
            }),
            catchError((error) => of(SummaryActions.exportSummaryFailure({ error })))
          )
        )
      )
    }
  );

  constructor(private actions$: Actions) { }
}
